import React from 'react';

const Line = () => <div className='moduleLine'/>

export default Line;